import { Link } from "react-router-dom";
import styles from "./styles.module.css";
import Logo from "../../../images/Logo.jpg";
import { ReactComponent as GlobeIcon } from "../../../images/svg/global.svg";
import { ReactComponent as PhoneIcon } from "../../../images/svg/call.svg";
import { SANOFT_LINKS, APP_VERSION } from "../../../const";

function AboutSanoft() {
  return (
    <>
      <div className={`${styles.container} ${styles.borderBottom}`}>
        <img src={Logo} alt="" style={{ height: "45px" }} />
        <span className={styles.subHeader}>Sanoft Technologies PVT. LTD</span>
        <div className={styles.contentWrapper}>
          <span className={styles.label}>Location :</span>
          <span>2nd Floor, KKM City Centre, Areekode,</span>
          <span>Malappuram, Kerala 673639</span>
        </div>
        <div className={styles.contentWrapper2}>
          <GlobeIcon className={styles.icon} />
          <Link className={styles.link} to={SANOFT_LINKS.WEB} target="_blank" rel="noopener noreferrer">
            www.sanoft.com
          </Link>
          <PhoneIcon className={styles.icon} />
          <span>+91 97463 93923 | +91 95674 53182 | +91 97466 93296</span>
        </div>
        <div className={styles.contentWrapper2}>
          <span className={styles.label}>Version :</span>
          <span>{APP_VERSION}</span>
        </div>
      </div>
      <div className={styles.container2}>
        <Link to={SANOFT_LINKS.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
        <Link to={SANOFT_LINKS.TERMS_AND_CONDITIONS} target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </Link>
        <Link to={SANOFT_LINKS.REFUND_POLICY} target="_blank" rel="noopener noreferrer">
          Refund Policy
        </Link>
      </div>
    </>
  );
}

export default AboutSanoft;
